import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "../../../types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import { MemberUserCompany } from "#/lib/carrot-api/types/MemberUserCompany"

const ENDPOINT = "GetMemberCompany"

const getBenefitCacheKey = (): (string | number)[] => [ENDPOINT]

export default function useGetMemberCompany(): UseQueryResult<MemberUserCompany, ResponseError> {
  return useQuery<MemberUserCompany, ResponseError>(getBenefitCacheKey(), () => carrotClient.getMemberUserCompany())
}
